/**
 * @Description:生成随机或者指定位数的英文数字组合
 * @author shuo.li
 * @date 2021.11.3
 * @LastEditors:
 * @LastEditTime:
 * @param {boolean} randomFlag	是否是随机生成位数, 为false时只需设置min即为位数，为true时需要min与max。
 * @param {number} min 			生成随机位数的最小数
 * @param {number} max			生成随机位数的最大数
 * @returns {string}				返回生成的英文数字组合
 */
export function randomCode(randomFlag, min, max) {
  let str = "";
  let range = min; // 默认赋值为第二个参数，如果是随机产生位数会通过下面的if改变。
  const arr = [
    "-",
    "_",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
  ];

  // 随机产生
  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min;
  }
  for (let i = 0; i < range; i++) {
    const index = Math.round(Math.random() * (arr.length - 1));
    str += arr[index];
  }
  return str;
}

